import { Controller } from '@hotwired/stimulus';
import { track } from '../lib/analytics';

export default class extends Controller {
  static values = { trackOnConnect: Boolean };

  connect() {
    if (this.trackOnConnectValue) {
      const event = this.element.dataset.analyticsEventParam;
      const properties = this.element.dataset.analyticsPropertiesParam;
      if (event) {
        track(event, properties ? JSON.parse(properties) : {});
      }
    }
  }

  track(event) {
    track(event.params.event, event.params.properties);
  }
}
